import over from 'ramda/es/over';
import lensPath from 'ramda/es/lensPath';

import {
  STUDENTS_REQUEST,
  STUDENTS_SUCCESS,
  STUDENTS_FAILURE,
} from 'app/actions/students';

import { STUDENT_UPDATE_SUCCESS } from 'app/actions/childSettings';


const defaultState = {
  loading: false,
  data: {},
  keys: [],
  err: '',
  didInvalidate: true,
  expired: 0,
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    /*
    *  PAYLOAD: undefined
    */
    case STUDENTS_REQUEST: {
      return ({ ...state, loading: true });
    }
    /*
    *  PAYLOAD: Object
    */
    case STUDENTS_SUCCESS: {
      return ({ ...state, ...action.payload, loading: false, didInvalidate: false });
    }
    /*
    *  PAYLOAD: Object {err: String}
    */
    case STUDENTS_FAILURE: {
      return ({ ...state, loading: false, err: action.payload.err, didInvalidate: false });
    }

    case STUDENT_UPDATE_SUCCESS: {
      return over(
        lensPath(['data', action.payload.studentId]),
        student => ({ ...student, ...action.payload.data }),
        state
      );
    }

    default:
  }

  return state;
}
